import { render, staticRenderFns } from "./CopPlot.vue?vue&type=template&id=2be5031e&"
import script from "./CopPlot.vue?vue&type=script&lang=js&"
export * from "./CopPlot.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports